export default class ChangeEventListItem{
    constructor() {
        this.addedItems = [];
        this.deletedItems = [];
    }
}